import { IAddress } from "../CustomTypes";
import fetchWithUuid from "./fetchWithUuid";
import checkError from "./checkError";
import {
  actionTypes,
  apiStatuses,
  CreateSpidUser,
  Deferred,
  ICreateSpidUserResult,
  productInfoDeferred
} from "./Actions";

const createSpidUser: CreateSpidUser = (
  email,
  firstName,
  lastName,
  phoneNumber,
  returnUrl,
  birthDate,
  address: IAddress
) => dispatch => {
  const failedCallback = (data: any) => {
    dispatch({
      data,
      status: apiStatuses.ERROR,
      type: actionTypes.CREATE_SPID_USER
    });
    return deferred.reject(data);
  };

  dispatch({ type: actionTypes.CREATE_SPID_USER, status: apiStatuses.LOADING });
  const deferred = new Deferred<ICreateSpidUserResult>();
  productInfoDeferred.promise
    .then(productInfo => {
      const {
        streetAddress,
        houseNumber,
        entrance,
        apartmentNumber,
        floor,
        zipCode,
        city,
        deliveryPointId
      } = address;
      const addressParams = `street=${encodeURIComponent(
        streetAddress
      )}&streetNumber=${encodeURIComponent(
        houseNumber
      )}&entrance=${encodeURIComponent(
        entrance
      )}&apartmentNumber=${encodeURIComponent(
        apartmentNumber
      )}&floor=${encodeURIComponent(floor)}&zipCode=${encodeURIComponent(
        zipCode
      )}&city=${encodeURIComponent(city)}&diId=${encodeURIComponent(
        deliveryPointId
      )}`;
      return fetchWithUuid(
        `/bestilling/c/${
          productInfo.owningClient
        }/api/v2/ff/createSpidUser.json?email=${encodeURIComponent(
          email
        )}&phoneNumber=${encodeURIComponent(
          phoneNumber
        )}&firstName=${encodeURIComponent(
          firstName
        )}&lastName=${encodeURIComponent(
          lastName
        )}&redirectUrl=${encodeURIComponent(
          returnUrl
        )}&dob=${encodeURIComponent(birthDate)}&${addressParams}`,
        {
          method: 'GET'
        }
      );
    }, failedCallback)
    .then(checkError)
    .then(res => res.json())
    .then(data => {
      dispatch({
        data,
        status: apiStatuses.SUCCESS,
        type: actionTypes.CREATE_SPID_USER
      });
      return deferred.resolve(data);
    })
    .catch(failedCallback);
  return deferred.promise;
};

export default createSpidUser;
